/**
 * ChatMessageGetReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * ChatMessageGetReq
 */
export interface ChatMessageGetReq {
  /** 消息ID，多个ID用逗号分隔 */
  id: string
}

/**
 * ChatMessageGetReq Schema
 */
export const ChatMessageGetReqSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '消息ID，多个ID用逗号分隔',
      format: 'string',
      type: 'string',
      label: '消息ID',
    },
  },
  required: ['id'],
  type: 'object',
}
